import { AfterViewInit, Component, OnDestroy, ChangeDetectionStrategy, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { DialogMaterialService } from "../../services/dialog-material.service";
import { UtenteService } from "../../services/utente.service";
import { Router } from "@angular/router";
import { EvCambioMedicoComponent } from "../cambio-medico/cambio-medico.component";
import { MatButton } from "@angular/material/button";

@Component({
    selector: 'ev-user-profile',
    styleUrls: ['./ev-user-profile.component.scss'],
    templateUrl: './ev-user-profile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton]
})
export class EvUserProfileComponent implements AfterViewInit, OnDestroy {
    utenteService = inject(UtenteService);
    private router = inject(Router);
    private dialogs = inject(DialogMaterialService);


    immagineProfilo
    nomeUtente
    nomeMedico
    dataScadenzaAbbonamento
    codiceFiscale
    isPagamentiVisibile
    isPagamentiVisibileSub: Subscription

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.nomeUtente = this.utenteService.getChiave(['paziente', 'nome']);
            this.nomeMedico = this.utenteService.getChiave(['paziente', 'medico']);
            this.dataScadenzaAbbonamento = this.utenteService.getChiave(['paziente', 'data_scadenza_abbonamento'])
            this.codiceFiscale = this.utenteService.getChiave(['paziente', 'codfis'])
            this.immagineProfilo = 'data:image/png;base64,' + this.utenteService.getChiave(['paziente', 'img'])
            this.isPagamentiVisibileSub = this.utenteService.datiUtentePresenti.subscribe(value => {
                if (value) {
                    this.isPagamentiVisibile = this.utenteService.isPagamentiVisibile()
                }
            })
        }, 0);
    }

    goToChangeImage() {
        this.router.navigate(['/impostazioni/cambiaImmagineProfilo'], {

        });
    }

    openChangeDoctor() {
        this.dialogs.open(EvCambioMedicoComponent, { width: '680px', maxWidth: '95vw' });
    }

    ngOnDestroy(): void {
        this.isPagamentiVisibileSub?.unsubscribe()
    }
}
